module.exports = __webpack_public_path__ + "img/auto-group.a01dfe72.png";